<script setup lang="ts">
import { computed } from 'vue';
import { RouterView } from 'vue-router';

import { UErrorView, useError } from '@support/core';

const { error } = useError();
const hasError = computed(() => Boolean(error.value?.statusCode));
</script>

<template>
  <div class="main-wrapper">
    <UErrorView v-if="hasError" />
    <RouterView v-else />
  </div>
</template>

<style scoped>
.main-wrapper {
  position: relative;
  flex: 1;
  height: 100%;
  /* The dashboard group around every layout clips its overflow, so a signed-out
     page taller than the viewport (a phone in landscape, a zoomed laptop) has
     to scroll here or its lower controls cannot be reached at all. */
  overflow-y: auto;
}
</style>
